<template>
  <div style="paddingTop: 200px">
    <p class="top">正在建设中，敬请期待</p>
    <p class="bottom" @click="goHome">返回首页</p>
  </div>
</template>
<script>
export default {
  methods: {
    goHome() {
      if (!this.$route) {
        location.href = `/`;
        return;
      }
      this.$router.push('/');
    }
  }
};
</script>
<style lang="less" scoped>
.top {
  text-align: center;
  color: #565555;
  font-size: 30px;
}
.bottom {
  text-align: center;
  color: #565555;
  font-size: 20px;
  cursor: pointer;
}
</style>
